import { FC, useContext } from 'react';
import { generatePath } from 'react-router-dom';

import {
  AddToProjectModalContext,
  MoreToolsDropdown,
  RECORD_TOOLS,
  SearchInstanceDto,
} from '@app/components';
import { Route } from '@app/constants';

import { SavedInstanceToolButton } from './SavedInstanceToolButton';

import css from './RecordsTools.module.scss';

interface RecordsToolsProps {
  entry: SearchInstanceDto;
}

export const RecordsTools: FC<RecordsToolsProps> = ({ entry }) => {
  const { dispatch: updateAddToProjectModalState } = useContext(
    AddToProjectModalContext
  );

  return (
    <div className={css.wrapper}>
      <SavedInstanceToolButton entry={entry} />
      <MoreToolsDropdown
        tools={[
          {
            ...RECORD_TOOLS.addToProject,
            onClick: () => {
              updateAddToProjectModalState({
                type: 'OPEN_MODAL',
                payload: {
                  id: entry.id,
                  redirectBackRoute: `${generatePath(Route.instanceDetails, {
                    id: entry.id,
                  })}?isAddToProject=true`,
                },
              });
            },
          },
        ]}
      />
    </div>
  );
};
